export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_TYPES_CLIENTS = 'SET_TYPES_CLIENTS'
